import forcyteService from './ForcyteService'

const BASE_URL = 'donor-portal/v2'

class DonorService {
  async updateDonor(dpDonorAuthId, formData) {
    return forcyteService.patch(
      `${BASE_URL}/donor/update-dp-donor-auth/${dpDonorAuthId}`,
      formData
    )
  }
  async confirmAppointment(payload) {
    return forcyteService.post(`${BASE_URL}/donor/confirm-appointment`, payload)
  }

  async getDonorAppointments(donorId, showAll = false) {
    return forcyteService.get(`${BASE_URL}/donor/${donorId}/appointments`, {
      params: { show_all: showAll },
    })
  }

  async cancelDonorAppointment(appointmentId) {
    return forcyteService.delete(
      `${BASE_URL}/donor/appointment/${appointmentId}`
    )
  }

  async rescheduleAppointment(payload) {
    return forcyteService.post(
      `${BASE_URL}/donor/reschedule-appointment`,
      payload
    )
  }

  async getDonorHealthHistory(donorId) {
    return forcyteService.get(`${BASE_URL}/donor/${donorId}/health-history`)
  }

  async getDonorBadges(donorId) {
    return forcyteService.get(`${BASE_URL}/donor/${donorId}/badges`)
  }

  async getLoyaltyAuth(params) {
    return forcyteService.get(`${BASE_URL}/donor/loyalty-auth`, {
      params,
    })
  }
}

const donorService = new DonorService()
export default donorService
